/**
 * The shape of a page-file row as the rest of the portal expects it. A pure module with no imports,
 * so the Playwright comparison can use the very same function the browser does rather than a copy.
 */

/**
 * One value, as the old path's XML parser would have delivered it. Found by comparing the two on
 * aial-dev (8 Oct 2026), where the first version rendered an EMPTY list: the page files carry
 * ContractNo as Pronto stores it, padded with leading spaces, and the page filters by contract with
 * an equality test, so nothing matched.
 *
 *   null              -> ''                (an empty element)
 *   padded text       -> trimmed           (the old path trimmed every value)
 *   2026-01-01T00:00:00 -> 2026-01-01      (the old path sent the date alone; the time is always midnight)
 *   digits only       -> a number          (the parser turns numeric text into numbers, and the portal
 *                                           was written against that, e.g. SerialNo)
 */
export function asOldPathValue(value: any): any {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value !== 'string') {
    return value;
  }

  const text = value.trim();

  const midnight = /^(\d{4}-\d{2}-\d{2})T00:00:00$/.exec(text);

  if (midnight) {
    return midnight[1];
  }

  if (/^[+-]?\d+(\.\d+)?$/.test(text) && Number.isSafeInteger(Number(text)) === !text.includes('.')) {
    return Number(text);
  }

  return text;
}

export function normaliseRow(row: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = {};

  Object.keys(row).forEach((key) => {
    out[key] = asOldPathValue(row[key]);
  });

  return out;
}
